module.exports = __webpack_public_path__ + "static/py-b9bbb1d722d3ef6ebf7d573703b5925e.png";